import React from "react";

function Orders() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#a45e26"
          d="M256 175.612l171.755 66.784V440.72L256 507.503 84.246 440.72V242.396z"
          data-original="#a45e26"
        ></path>
        <path
          fill="#a35623"
          d="M256 175.612l171.755 66.784V440.72L256 507.503z"
          data-original="#a35623"
        ></path>
        <path
          fill="#c36a26"
          d="M256 308.97l-39.064 67.662L45 309.778l39.064-67.662zm0 0l39.064 67.662L467 309.778l-39.064-67.662z"
          data-original="#c36a26"
        ></path>
        <path
          fill="#9b5d2b"
          d="M427.486 242.29L256 175.612 84.514 242.29 256 308.97z"
          data-original="#9b5d2b"
        ></path>
        <path
          fill="#824e2b"
          d="M427.486 242.29L256 175.612V308.97z"
          data-original="#824e2b"
        ></path>
        <path
          fill="#b7d341"
          d="M255.985 263.835c48.579 0 88.2-39.621 88.2-88.201 0-48.578-39.621-88.199-88.2-88.199s-88.2 39.621-88.2 88.199c0 48.58 39.621 88.201 88.2 88.201z"
          data-original="#62a4fb"
        ></path>
        <path
          fill="#eff4f7"
          d="M289.381 135.413c4.994-4.993 13.088-4.993 18.081 0 4.993 4.992 4.993 13.088 0 18.08l-62.364 62.365c-5.654 5.654-14.996 4.765-19.534-1.734l-26.237-33.019c-4.387-5.517-3.47-13.546 2.047-17.931 5.518-4.387 13.545-3.47 17.932 2.047l17.83 22.438z"
          data-original="#eff4f7"
        ></path>
        <path
          fill="#fad808"
          d="M417.018 169.74a8 8 0 110 15.999h-37.469a8 8 0 110-15.999zM247.984 12.497a8 8 0 0116 0v37.469a8 8 0 11-16 0zm-80.755 24.774a7.965 7.965 0 012.938-10.875 7.965 7.965 0 0110.875 2.938l18.734 32.448a7.965 7.965 0 11-13.813 7.937zm-57.577 61.878a7.98 7.98 0 01-2.906-10.906 7.98 7.98 0 0110.905-2.906l32.448 18.734a7.981 7.981 0 11-8 13.812zm-18.91 82.38a8 8 0 110-15.999h37.469a8 8 0 110 15.999zM330.365 31.438a7.965 7.965 0 1113.813 7.938l-18.734 32.448a7.967 7.967 0 01-10.875 2.938 7.969 7.969 0 01-2.938-10.876zm61.848 57.545a7.982 7.982 0 0110.907 2.906 7.982 7.982 0 01-2.907 10.906l-32.448 18.734a7.981 7.981 0 01-8-13.812z"
          data-original="#fad808"
        ></path>
      </g>
    </svg>
  );
}

export default Orders;
